import { Outlet } from "react-router-dom";

import SnippetsContainer from "@components/snippets-ui/SnippetsContainer";

import { styled } from "@mui/material";

const Root = styled("div")(({ theme }) => ({
  width: "100%",
  marginBottom: "3em",
  ...theme.typography.body2,
}));

const SnippetsLayout = () => {
  return (
    <Root>
      <SnippetsContainer />
      <Outlet />
    </Root>
  );
};

export default SnippetsLayout;
